import { createV3Queries } from "@query/utils/createV3Queries";
import { sharedFileRequestConfigurationsApi } from "@api";
import {
  QUERY_EXTENDED_REQUIREMENT_DEFINITION,
  QUERY_EXTENDED_REQUIREMENT_DEFINITIONS
} from "../../query/requirementDefinitions/keys";

/**
 * Shared-file-request-configuration registry — mirrors
 * `SharedFileRequestConfigurationsApi` 1:1
 * (`/v3/compliance/shared-file-request-configurations`). This is the v3 twin of
 * the v1 `/shared-files/settings` resource: the reusable template (title,
 * accepted mime types, instructions, context type) a `DocumentUpload`
 * requirement definition points at through its `dataSourceId`, and that every
 * shared-file *request* is minted from.
 *
 * A configuration edit changes what the "extended" requirement-definition reads
 * show — those join a v3 template with its data-source settings and live
 * outside this registry's cache space, so `update` invalidates them explicitly.
 * `create` needs no such fan-out: a definition only references a configuration
 * once the definition itself is created, which carries its own invalidation.
 */
export const queriesSharedFileRequestConfigurations = createV3Queries(
  "sharedFileRequestConfigurationsApi",
  sharedFileRequestConfigurationsApi,
  {
    updateSharedFileRequestConfiguration: () => ({
      dependencies: () => [
        QUERY_EXTENDED_REQUIREMENT_DEFINITION,
        QUERY_EXTENDED_REQUIREMENT_DEFINITIONS
      ]
    })
  }
);
